import React, { useEffect } from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const ProjectManagement = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--service-bg-image',
      "url('https://images.unsplash.com/photo-1553877522-43269d4ea984?q=80&w=2070&auto=format&fit=crop')"
    );
    return () => {
      document.documentElement.style.removeProperty('--service-bg-image');
    };
  }, []);
  const benefits = [
    {
      title: 'On-Time Delivery',
      description: 'Ensure your projects are completed on schedule with effective planning and execution management.'
    },
    {
      title: 'Budget Control',
      description: 'Keep projects within budget through careful resource allocation and cost management.'
    },
    {
      title: 'Quality Assurance',
      description: 'Maintain high quality standards throughout the project lifecycle with systematic oversight.'
    },
    {
      title: 'Stakeholder Satisfaction',
      description: 'Keep all stakeholders informed and engaged, ensuring alignment and satisfaction with project outcomes.'
    }
  ];

  const features = [
    'Project planning and scheduling',
    'Resource allocation and management',
    'Risk identification and mitigation',
    'Budget tracking and cost control',
    'Quality assurance and control',
    'Stakeholder communication and reporting',
    'Team coordination and leadership',
    'Change management and control',
    'Project documentation and reporting',
    'Post-project evaluation and lessons learned'
  ];

  const process = [
    {
      title: 'Initiation',
      description: 'Define project scope, objectives, and success criteria. Identify stakeholders and establish project governance structure.'
    },
    {
      title: 'Planning',
      description: 'Develop comprehensive project plans including timelines, resources, budget, risk management, and communication strategies.'
    },
    {
      title: 'Execution',
      description: 'Coordinate team activities, manage resources, and ensure project deliverables meet quality standards and requirements.'
    },
    {
      title: 'Monitoring & Control',
      description: 'Track progress, manage changes, and ensure the project stays on track with regular reporting and stakeholder updates.'
    },
    {
      title: 'Closure',
      description: 'Complete final deliverables, conduct project review, document lessons learned, and ensure smooth handover.'
    }
  ];

  return (
    <ServiceTemplate
      icon="🎯"
      title="Project Management"
      subtitle="Professional project oversight to ensure successful delivery on time and within budget"
      description="Our project management services ensure your initiatives are executed efficiently and effectively. With proven methodologies and experienced project managers, we guide your projects from conception to completion, delivering results that meet or exceed expectations while managing risks and optimizing resources."
      benefits={benefits}
      features={features}
      process={process}
      callToAction="Ready to bring your project to successful completion? Contact us to discuss how our project management expertise can help you achieve your goals."
    />
  );
};

export default ProjectManagement;

